import React from 'react';
import heroImg from '../../assets/hero.jpeg';
import './Hero.css';

function Hero() {
  return (
    <header
      id="home"
      className="hero"
      style={{ backgroundImage: `url(${heroImg})` }}
    />
  );
}

export default Hero;
